import { ChevronRightIcon, MailIcon } from "@heroicons/react/solid";
import { FaFileContract, FaSpinner } from "react-icons/fa";
import { INewTemplate } from "../api/services/messaging.service";

export default function TemplateListSection({
  templates,
  onSelected,
  selectedTemplate,
  loading,
}: {
  templates: INewTemplate[];
  onSelected: (template: INewTemplate) => void;
  selectedTemplate: INewTemplate | null;
  loading: boolean;
}) {
  function TemplateListRow({
    template,
    onSelected,
    isSelected,
  }: {
    template: INewTemplate;
    onSelected: (template: INewTemplate) => void;
    isSelected: boolean;
  }) {
    return (
      <div
        className={`break-all py-4 px-4 cursor-pointer ${
          isSelected ? "bg-gray-100 rounded" : ""
        }`}
        onClick={() => onSelected(template)}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="flex-shrink-0 mr-3 break-all">
              <FaFileContract
                className={`h-10 w-10 text-slate-400 ${
                  isSelected ? "text-red-600" : ""
                }`}
              />
            </div>
            <div className="break-all">
              <p className="text-sm font-medium text-red-600 break-all">
                {template.event}
              </p>
              <p className="mt-2 flex items-start text-sm text-gray-500 break-all">
                <MailIcon
                  className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
                {template.type}
              </p>
            </div>
          </div>
          <div className="flex">
            <ChevronRightIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col rounded-2xl shadow-xl bg-white grow">
      <div className="flex items-center p-4 w-full border-b justify-between">
        <div className="flex items-center">
          <div className="flex items-center mr-10 rounded-lg">
            <div className="">
              <FaFileContract size={20} className="text-red-700" />
            </div>
            <span className="ml-2 font-medium leading-6 text-slate-700 text-lg flex ">
              Templates
            </span>
          </div>
        </div>
      </div>
      {loading && (
        <div className="flex items-center justify-center p-20 text-slate-500">
          <FaSpinner size={30} className="animate-spin" />
        </div>
      )}
      {!loading && templates.length > 0 && (
        <div className="flex flex-col divide-y divide-gray-200 w-full overflow-scroll overflow-x-hidden ">
          {templates.map((template, i) => (
            <TemplateListRow
              key={i}
              template={template}
              isSelected={selectedTemplate?.event === template.event}
              onSelected={() => {
                onSelected(template);
              }}
            />
          ))}
        </div>
      )}
      {!loading && templates.length === 0 && (
        <div className="flex flex-col items-center justify-center p-8 text-slate-500">
          <div className="font-semibold text-slate-700 mb-2">
            No Users found
          </div>
          <div className="inline-flex items-center space-x-2">
            <div>Maybe try different search parameters</div>
          </div>
        </div>
      )}
      {/* <Pagination {...paginationProps} goToPage={setPage} /> */}
    </div>
  );
}
